// Bootstrap (plan §3): read the served environment, then mount the provider stack and router.
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './styles.css';
import { readEnvironment } from './env/environment.ts';
import { createApp } from './app/AppRoot.tsx';

const container = document.getElementById('app');
if (container === null) throw new Error('index.html has no #app');

createRoot(container).render(<StrictMode>{createApp({ environment: readEnvironment() })}</StrictMode>);
